export default {
  errors: ({ errors }) => errors,
}